export type status = 'success' | 'error' | 'failure' | 'fetching' | 'init';

export enum OrderStatus {
  IN_PROGRESS = 6,
  COMPLETED = 8,
}
